const routes = [
  {
    path: "/",
    component: () => import("pages/Index.vue")
  },
  {
    path: "/widget",
    component: () => import("pages/Widget.vue")
  },
  {
    path: "/link",
    component: () => import("pages/Link.vue")
  },
  {
    path: "/meeting",
    component: () => import("pages/Meeting/Meeting.vue")
  },
  {
    path: "/preview",
    component: () => import("pages/Meeting/Preview.vue")
  },
  {
    path: "/end-session",
    component: () => import("pages/EndSession.vue")
  },
  {
    path: "/sequence",
    component: () => import("pages/Sequence.vue")
  },
  {
    path: '/desktop*',
    component: () => import("pages/Desktop.vue")
  },
  {
    path: '/internal/preview/card',
    component: () => import("pages/Internal/CardPreview.vue")
  },
  {
    path: '/internal/preview/widget',
    component: () => import("pages/Internal/WidgetPreview.vue")
  },
  {
    path: '/internal/preview/standby',
    component: () => import("pages/Internal/StandByPreview.vue")
  },
  {
    path: '/internal/preview/endSession',
    component: () => import("pages/Internal/EndSessionPreview.vue")
  },
  {
    path: '/internal/preview/businessCard',
    component: () => import("pages/Internal/EndSessionPreview.vue")
  },
  {
    path: "*",
    component: () => import("pages/Error404.vue")
  }
];

export default routes;
